/*
 * @Description: 我的发票接口
 * @Author: ywj
 * @Date: 2025-04-09 16:43:07
 * @LastEditTime: 2025-04-25 14:29:55
 * @LastEditors: ywj@originqc.com
 */
import request from '@/utils/request';



// 发票列表
export const getBillList = (data: any) =>
  request({
    url: `attachCenter/invoice/getBillList.json`,
    method: 'post',
    data,
  });


// 申请开票
export const createBill = (data: any) =>
  request({
    url: `attachCenter/invoice/createBill.json`,
    method: 'post',
    data,
  });
  // 查看发票
  export const getBill = (orderId:number|string) =>
  request({
    url: `attachCenter/invoice/getBill.json?orderId=${orderId}`,
  });


  /** 开票基本信息 */
export const getBaseInfo = (orderId:number|string) =>
request({
  url: `attachCenter/invoice/getBaseInfo.json?orderId=${orderId}`,
});

// 修改开票信息

export const updateBillInfo = (data:any) =>
request({
  url: `attachCenter/invoice/updateBillInfo.json`,
  method: 'post',
  data,
});


//发票下载
export const downloadBill = (orderId:number|string) =>
request({
  url: `attachCenter/invoice/downloadBill.json?orderId=${orderId}`,
 
});


//核对发票状态
export const updateCheck = (data: {id:number|string,orderId:number|string}) =>
request({
  url: `attachCenter/invoice/updateCheck.json`,
  method: 'post',
 data ,
});